import { useState, useEffect } from "react";
import axios from "axios";
import { Card } from "react-bootstrap";
import "./design/change_password.css";
import { useNavigate } from "react-router-dom";

const CambiarPassword = () => {
  const [form, setForm] = useState({ actual: "", nueva: "" });
  const [mensaje, setMensaje] = useState("");
  const [valida, setValida] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const updatedForm = { ...form, [e.target.name]: e.target.value };
    setForm(updatedForm);

    // Validar en tiempo real
    if (e.target.name === "nueva") {
      setValida(validarPassword(e.target.value));
    }
  };

  const validarPassword = (password) => {
    const tieneMinimoCaracteres = password.length >= 6;
    const tieneLetra = /[a-zA-Z]/.test(password);
    const tieneNumero = /\d/.test(password);
    return tieneMinimoCaracteres && tieneLetra && tieneNumero;
  };


  const [confirmarNueva, setConfirmarNueva] = useState("");

  const handleConfirmarNuevaChange = (e) => {
    setConfirmarNueva(e.target.value);
  };

  useEffect(() => {
    if (form.nueva !== confirmarNueva) {
      setMensaje("Las contraseñas no coinciden");
      setValida(false);
    } else {
      setMensaje("");
      setValida(validarPassword(form.nueva));
    }
  }, [confirmarNueva, form.nueva]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!valida) {
      setMensaje("La nueva contraseña no cumple con los requisitos o no coincide.");
      return;
    }

    try {
      await axios.put("http://192.168.1.81:5000/backend/api/socio/cambiar-password", form, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      window.alert("Contraseña cambiada correctamente.");
      setForm({ actual: "", nueva: "" });
      setConfirmarNueva("");
      setValida(false);
      localStorage.removeItem("token");
      navigate('/login/socio');
      window.location.reload();
    } catch (err) {
      console.error("Error:", err);
      setMensaje("Error al cambiar la contraseña. Verifica tu contraseña actual.");
    }
  };

  return (
    <div>
      <Card className="change-password-card">
        <h3>Cambiar contraseña</h3><br />

        <form onSubmit={handleSubmit}>
          <input
            type="password"
            name="actual"
            placeholder="Contraseña actual"
            value={form.actual}
            onChange={handleChange}
            required
          />
          <br /><br />
          <input
            type="password"
            name="nueva"
            placeholder="Nueva contraseña"
            value={form.nueva}
            onChange={handleChange}
            required
          />
          <br /><br />
          <input
            type="password"
            name="confirmarNueva"
            placeholder="Confirmar nueva contraseña"
            value={confirmarNueva}
            onChange={handleConfirmarNuevaChange}
            required
          />
          <br />
          <small style={{ color: "GrayText" }}>
            La nueva contraseña debe:
            <br />
            <strong>* Tener al menos 6 caracteres</strong><br />
            <strong>* Incluir al menos 1 letra y 1 número</strong>
          </small>
          {mensaje && <p style={{ color: "red", fontWeight: "bold" }}>{mensaje}</p>}
          <p style={{ color: valida ? "green" : "red", fontWeight: "bold" }}>
            {form.nueva.length > 0 && (valida ? "✅ Contraseña válida" : "❌ Contraseña no válida")}
          </p>
          <button type="submit" disabled={!valida}>Cambiar contraseña</button>
        </form>
        {mensaje && <p style={{ color: mensaje.includes("correctamente") ? "green" : "red" }}>{mensaje}</p>}
      </Card>
    </div>

  );
};

export default CambiarPassword;
